module.exports = __webpack_public_path__ + "img/rdccovid19.89325f14.png";